import { useState, useContext, useEffect } from "react";
import "./styles/ChangePassword.css";
import "./styles/Button.css";
import Navbar from "../components/scripts/Navbar";
import UserContext from "../components/Common/UserContext";
import Api_Call from "../ApiCall";
import { ReactComponent as GreenSvg } from "./../assets/green-tick.svg";
import { ReactComponent as CrossSvg } from "./../assets/cross-icon.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Box } from "@mui/material";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import ErrorPage from "../components/Common/ErrorPage";
import { error } from "jquery";
import menus from "../user-config.json";

const UpdateModal = ({ isOpen, onClose, autoHideTimeout, message }) => {
  const [visible, setVisible] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
    }
  }, [isOpen]);
  const handleOKClick = () => {
    onClose(); // Close the modal or perform any necessary cleanup
    console.log(
      menus[sessionStorage.getItem("userRole").toLowerCase()]["menus"].find(
        (item) => item.landingPage === true
      )["route"]
    );
    window.location.href = menus[
      sessionStorage.getItem("userRole").toLowerCase()
    ]["menus"].find((item) => item.landingPage === true)["route"]; // Redirect to '/AuditHome'
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="confirmation-modal">
      <div className="confirmation-modal-content">
        <h1 style={{ display: "flex", alignItems: "center" }}>
          <GreenSvg style={{ margin: "10px" }} />
          Password Updated Successfully
        </h1>
        <div style={{ textAlign: "center", margin: "10px 0" }}>
          <button onClick={handleOKClick}>OK</button>
        </div>
        {/* <p> {message} %</p> */}
      </div>
    </div>
  );
};
const ChangePassword = () => {
  const { accessToken } = useContext(UserContext);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [isPass8characterLong, setisPass8characterLong] = useState(false);
  const [isPassHasUpperCase, setisPassHasUpperCase] = useState(false);
  const [isPassHasSpecialChar, setisPassHasSpecialChar] = useState(false);
  const [isUpdateModalOpen, setisUpdateModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState();
  const [isError, setIsError] = useState(false);
  const history = useHistory();
  useEffect(() => {
    setisPassHasUpperCase(false);
    setisPassHasSpecialChar(false);
    setisPass8characterLong(false);
    if (newPassword.length >= 8) {
      setisPass8characterLong(true);
    }

    if (/[!@#$%^&*()_+=\[{\]};:<>|./?,-]/.test(newPassword)) {
      setisPassHasSpecialChar(true);
    }

    if (/[A-Z]/.test(newPassword)) {
      setisPassHasUpperCase(true);
    }
  }, [newPassword]);
  const submitHandler = async () => {
    let payload;
    if (accessToken) {
      payload = {
        user_name: sessionStorage.getItem("userName"),
        old_password: oldPassword,
        new_password: newPassword,
        access_token: accessToken,
      };
    } else {
      payload = {
        user_name: sessionStorage.getItem("userName"),
        old_password: oldPassword,
        new_password: newPassword,
        // access_token: "",
      };
    }
    console.log(payload);
    setIsLoading(true);
    try {
      const api = new Api_Call();
      const data = await api.postData(`USER/CHANGE_PASSWORD`, payload);
      if (data.success == false) {
        throw new Error("Error Occured");
      }
      console.log(data.body);
      setisUpdateModalOpen(true);
    } catch (error) {
      setIsError(true);
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  if (isError) {
    return (
      <ErrorPage message="Unexpected Error Occured" code={404}></ErrorPage>
    );
  }

  const stylesForCross = {
    transform: "scale(1.5)",
    margin: "5px",
  };

  if (isLoading) {
    return (
      <Box className="loader-wrapper">
        <div className="loader"></div>
      </Box>
    );
  }
  return (
    <>
      <Box
        className="login-main"
        style={{
          background: 'url("img/login-bg.png")',
          backgroundSize: "cover",
          boxShadow: "inset 0 0 0 2000px #fb4e0bc4 ",
        }}
      >
        <Paper
          elevation={10}
          className="paper-circle"
          style={{
            height: "550px",
            width: "550px",
            top: "100px",
            left: "50px",
            // transform: "translateX(-50%)",
          }}
        >
          <Grid align="center" style={{ position: "absolute", top: "100px" }}>
            <h2 className="header--change--password">
              Welcome, {sessionStorage.getItem("Name")}
            </h2>
            <div className="password-change-section">
              <div className="password-change-element">
                <label
                  className="password-change-element__label"
                  htmlFor="oldpassword"
                >
                  Old Password
                </label>
                <input
                  className="password-change-element__input "
                  id="oldpassword"
                  onChange={(e) => {
                    setOldPassword(e.target.value);
                  }}
                  type="password"
                  style={{ borderRadius: 25 }}
                ></input>
              </div>

              <div className="password-change-element">
                <label
                  className="password-change-element__label "
                  htmlFor="newpassword"
                >
                  New Password
                </label>
                <input
                  className="password-change-element__input "
                  id="newpassword"
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                  }}
                  type="password"
                  style={{ borderRadius: 25 }}
                ></input>
              </div>

              <div className="password-change-element">
                <label
                  className="password-change-element__label"
                  htmlFor="confirmpassword"
                >
                  Confirm Password
                </label>

                <div>
                  <input
                    className="password-change-element__input "
                    id="confirmpassword"
                    onChange={(e) => {
                      setConfirmNewPassword(e.target.value);
                    }}
                    type="password"
                    style={{ borderRadius: 25 }}
                  ></input>
                  {/* {newPassword && (
                    <div className="error-messages">
                      <div className="error-message">
                        {isPass8characterLong ? (
                          <GreenSvg></GreenSvg>
                        ) : (
                          <CrossSvg style={{ color: "red" }}></CrossSvg>
                        )}
                        <span>
                          Password should be more than 8 character long
                        </span>
                      </div>

                      <div className="error-message">
                        {isPassHasUpperCase ? (
                          <GreenSvg></GreenSvg>
                        ) : (
                          <CrossSvg></CrossSvg>
                        )}
                        <span>
                          Password should atleast have one Uppercase character
                        </span>
                      </div>

                      <div className="error-message">
                        {isPassHasSpecialChar ? (
                          <GreenSvg></GreenSvg>
                        ) : (
                          <CrossSvg></CrossSvg>
                        )}
                        <span>
                          Password should atleast have one special character
                        </span>
                      </div>

                      <div className="error-message">
                        {newPassword == confirmNewPassword &&
                        newPassword &&
                        confirmNewPassword ? (
                          <GreenSvg></GreenSvg>
                        ) : (
                          <CrossSvg></CrossSvg>
                        )}
                        <span>
                          Password must be same in both New Password and Confirm
                          Password
                        </span>
                      </div>
                    </div>
                  )} */}
                </div>
              </div>

              {newPassword && (
                <div className="error-messages">
                  <div className="error-message">
                    {isPass8characterLong ? (
                      <GreenSvg></GreenSvg>
                    ) : (
                      <CrossSvg
                        style={{ color: "red", ...stylesForCross }}
                      ></CrossSvg>
                    )}
                    <span>Password should be more than 8 character long</span>
                  </div>

                  <div className="error-message">
                    {isPassHasUpperCase ? (
                      <GreenSvg></GreenSvg>
                    ) : (
                      <CrossSvg style={stylesForCross}></CrossSvg>
                    )}
                    <span>
                      Password should atleast have one Uppercase character
                    </span>
                  </div>

                  <div className="error-message">
                    {newPassword == confirmNewPassword &&
                    newPassword &&
                    confirmNewPassword ? (
                      <GreenSvg></GreenSvg>
                    ) : (
                      <CrossSvg style={stylesForCross}></CrossSvg>
                    )}
                    <span>Password must be same in both Inputs</span>
                  </div>
                  <div className="error-message">
                    {isPassHasSpecialChar ? (
                      <GreenSvg></GreenSvg>
                    ) : (
                      <CrossSvg style={stylesForCross}></CrossSvg>
                    )}
                    <span>
                      Password should atleast have one special character
                    </span>
                  </div>
                </div>
              )}
            </div>
            <UpdateModal
              isOpen={isUpdateModalOpen}
              onClose={() => {
                setisUpdateModalOpen(false);
              }}
            ></UpdateModal>
            {/* <div className="error-message">
        {isPass8characterLong ? <GreenSvg></GreenSvg> : <CrossSvg></CrossSvg>}
        <span>Password should be more than 8 character long</span>
      </div>

      <div className="error-message">
        {isPassHasUpperCase ? <GreenSvg></GreenSvg> : <CrossSvg></CrossSvg>}
        <span>Password should atleast have one Uppercase character</span>
      </div>

      <div className="error-message">
        {isPassHasSpecialChar ? <GreenSvg></GreenSvg> : <CrossSvg></CrossSvg>}
        <span>Password should atleast have one special character</span>
      </div>

      <div className="error-message">
        {newPassword == confirmNewPassword &&
        newPassword &&
        confirmNewPassword ? (
          <GreenSvg></GreenSvg>
        ) : (
          <CrossSvg></CrossSvg>
        )}
        <span>
          Password must be same in both New Password and Confirm New Password
        </span>
      </div> */}
            {/* <div className="submit">
        <button
          className="btn btn--primary btn--medium"
          onClick={submitHandler}
          disabled={
            !(
              isPass8characterLong &&
              isPassHasSpecialChar &&
              isPassHasUpperCase &&
              newPassword == confirmNewPassword
            )
          }
        >
          Update
        </button>
      </div> */}
            {/* <div className="submit">
              <button
                className="btn btn--primary btn--medium"
                
                disabled={
                  !(
                    isPass8characterLong &&
                    isPassHasSpecialChar &&
                    isPassHasUpperCase &&
                    newPassword == confirmNewPassword
                  )
                }
              >
                Update
              </button>
            </div> */}
            <Button
              type="submit"
              variant="contained"
              disabled={
                !(
                  isPass8characterLong &&
                  isPassHasSpecialChar &&
                  isPassHasUpperCase &&
                  newPassword == confirmNewPassword
                )
              }
              style={{
                borderRadius: 25,
                color: "#fff",
                marginTop: "20px",
              }}
              onClick={submitHandler}
            >
              Update
            </Button>
          </Grid>
        </Paper>
      </Box>
    </>
  );
};

export default ChangePassword;
